
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import { ControlColor } from "@/oxygen/classes/lib/types";
import { ColorInputValue, ColorOptions } from "@/types/colors";
import ColorInput from "@/components/Reusable/CustomInputs/Color/ColorInput.vue";
import ColorPicker from "@/components/Reusable/CustomInputs/Color/ColorPicker.vue";

@Component({
  components: { ColorPicker, ColorInput }
})
export default class OxygenColorInput extends Vue {
  @Prop()
  control!: ControlColor;

  @ModelSync("value", "input")
  syncedValue?: ColorInputValue;

  @Prop()
  placeholder?: string;

  get options(): ColorOptions {
    return {
      type: this.control?.colorType || "solidOnly"
    };
  }
}
